import DashboardMode from "./DashboardMode";

export const SearchFieldsMap = {
    [DashboardMode.JOBS]: [
        "Request Name", "Requestor Name", "Requestor email ID", "Job ID", "Sender’s Account [Aspera account name, Aspera P2P, Screeners]",
        "Asset Title", "Asset Name", "XMN #", "Asset ID",
        "Source Filename/ID & Filename or ID & Source ID (Bundle)", 
        "Interplay ID", "ID #",
        "Source File ID (Title ID / CID)", "ID Number", "Processing - Final Filename", "Processing - Filetype",
        "Drive Xytech #", "Episode Name", "Episode #", "Source - Final Filename", "Assigned To",
    ],
    [DashboardMode.REQUESTS]: [
        "Request Name", "Requestor Name", "Requestor email ID",
        "Request ID", "Department"
    ]
};
